import { MButton } from '@assets/mui/@material-extend';
import { useBitrix } from '@context/useBitrixUser/useBitrix';
import Typography from '@mui/material/Typography';
import { companyProfileService } from '@services/requests/companyProfileService';
import { MainData } from '@services/requests/companyProfileService/types/mainData';
import React, { useState } from 'react';

import { ChangeNotification } from '../../ChangeNotification';
import { BankDetailsItem } from './BankDetailsItem';
import { DefaultBankDetails } from './DefaultBankDetails';
import { BankDetailsModuleStyledContainer } from './StyledComponents';
import { BankDetailsFormFields } from './types';

interface BankDetailsProps {
  mainData: MainData;
  isAllowEdit: boolean;
}

function BankDetailsModule({ mainData, isAllowEdit }: BankDetailsProps) {
  const { fields: bankRequisitesFields } = mainData.sections.bank_requisites;

  const [isChangeNotificationOpen, setIsChangeNotificationOpen] = useState<boolean>(false);

  const [bankDetails, setBankDetails] = useState<BankDetailsFormFields[]>(() =>
    bankRequisitesFields.map((bankItem) => ({
      id: bankItem.id.value,
      bankName: bankItem.name.value ?? '',
      bankAddress: bankItem.address.value ?? '',
      currentAccount: bankItem.acc_num.value ?? '',
      correspondentAccount: bankItem.cor_acc_num.value ?? '',
      currency: bankItem.acc_currency.value ?? '',
      bik: bankItem.bik.value ?? '',
      swift: bankItem.swift.value ?? '',
      defaultDetails: bankItem.is_default.value,
    }))
  );

  const { useBitrixUser } = useBitrix();
  const [{ bitrixUser }] = useBitrixUser().useState();

  const removeDefaultDetailsHandler = (excludeIndex: number) => {
    setBankDetails((prevState) => {
      const newState = prevState.map((bankDetails, index) => {
        if (excludeIndex === index) {
          return bankDetails;
        }
        return { ...bankDetails, defaultDetails: false };
      });

      return newState;
    });
  };

  //   const changeBankDetailsHandler = <T extends keyof BankDetailsFormFields>(
  //     index: number,
  //     key: T,
  //     value: BankDetailsFormFields[T]
  //   ) => {
  //     setBankDetails((prevState) => {
  //       const newBankItem = { ...prevState[index] };
  //       newBankItem[key] = value;

  //       const newState = [...prevState];
  //       newState.splice(index, 1, newBankItem);

  //       return newState;
  //     });
  //   };

  const addBankDetailsHandler = () => {
    setBankDetails((prevState) => [...prevState, new DefaultBankDetails()]);
  };

  const removeBankDetailsHandler = async (
    bankIndex: number,
    id: string,
    onError: (errors: string[]) => void
  ) => {
    if (bankDetails.length === 1) {
      return;
    }

    if (!id.includes('new-bank-details')) {
      const result = await companyProfileService().DeleteBankDetails(bitrixUser.id, id);

      if (!result.success) {
        onError(result.errors ?? []);
        return;
      }
    }

    setIsChangeNotificationOpen(true);
    setBankDetails((prevState) => [
      ...prevState.slice(0, bankIndex),
      ...prevState.slice(bankIndex + 1),
    ]);
  };

  return (
    <>
      <BankDetailsModuleStyledContainer>
        {bankDetails.map((item, index) => {
          return (
            <BankDetailsItem
              key={item.id}
              index={index}
              isAllowEdit={isAllowEdit}
              bankDetailsItem={item}
              bankDetails={bankDetails}
              mainData={mainData}
              onRemoveBankDetails={removeBankDetailsHandler}
              //   onChangeBankDetails={changeBankDetailsHandler}
              onRemoveDefaultDetails={removeDefaultDetailsHandler}
            />
          );
        })}
        {isAllowEdit && (
          <div>
            <MButton
              className={'main-tab-button'}
              variant={'outlined'}
              color={'secondary'}
              onClick={addBankDetailsHandler}
            >
              <Typography color={'#3460B4'} fontSize={16} fontWeight={600}>
                {mainData.messages.btn_add_bank_details}
              </Typography>
            </MButton>
          </div>
        )}
      </BankDetailsModuleStyledContainer>
      <ChangeNotification
        needReviewType={false}
        isOpen={isChangeNotificationOpen}
        onClose={() => setIsChangeNotificationOpen(false)}
      />
    </>
  );
}
export { BankDetailsModule };
